export const DEFAULT_RENDER_DEBOUNCE_MS = 100;
export const LARGE_RENDER_DEBOUNCE_MS = 280;
export const LARGE_RENDER_PIXEL_THRESHOLD = 8_000_000;
export const IPAD_RENDER_PIXEL_THRESHOLD = 4_000_000;

export function renderDebounceMsForSource(
  source: { width: number; height: number } | null,
  isIpadLikeDevice: boolean,
): number {
  if (!source) return 0;
  const pixels = source.width * source.height;
  if (pixels >= LARGE_RENDER_PIXEL_THRESHOLD) return LARGE_RENDER_DEBOUNCE_MS;
  if (isIpadLikeDevice && pixels >= IPAD_RENDER_PIXEL_THRESHOLD) {
    return LARGE_RENDER_DEBOUNCE_MS;
  }
  return DEFAULT_RENDER_DEBOUNCE_MS;
}
